import React from 'react';

import './SellMultipleAddressReview.scss';

import SellAddressReview from '../SellAddressReview';
import SellDeductionsReviewRow from '../SellDeductionsReviewRow/SellDeductionsReviewRow';
import SellFundReviewRow from '../SellFundReviewRow/SellFundReviewRow';
import SellSelectedFundAmount from '../SellSelectedFundAmount/SellSelectedFundAmount';
import SellTradeDateReviewRow from '../SellTradeDateReviewRow/SellTradeDateReviewRow';
import SellTransactionEstimation from '../SellTransactionEstimation/SellTransactionEstimation';
import { mailCheckToNamePicker } from '../../../../utils/funds/funds-utility';
import { isCollegeDistribute } from '../../../../utils/transactions-util';
import { COLLEGE_DISTRIBUTE_PAYEE_OPTIONS } from '../../../../settings/settings';

const SellMultipleAddressReview = ({
  deliveryMethod,
  displayTradeDate,
  fundsByAddressLookup,
}) => (
  <div className="row sell-multiple-address-review">
    {Object.keys(fundsByAddressLookup).map((Address) => {
      const funds = fundsByAddressLookup[Address].funds;
      const data = fundsByAddressLookup[Address].groupData;
      const {
        isTakeHomeEstimated,
        sellTotalAmount,
        sellTotalDeduction,
        sellTotalTakeHomeAmount,
      } = data;
      return (
        <div key={Address}>
          {funds.map((fund, index) => {
            const firstFund = index === 0;
            const address =
              (fund.payee === COLLEGE_DISTRIBUTE_PAYEE_OPTIONS.BENEFICIARY &&
                fund.mailCheckBeneficiaryAddress) ||
              fund.address;
            return (
              <div key={fund.agreementID}>
                <div className="col-md-5 col-sm-6 col-xs-12 sell-multiple-address-review-mobile-border">
                  {firstFund && (
                    <div className="sell-multiple-address-review-address">
                      <SellAddressReview
                        address={address}
                        name={mailCheckToNamePicker(fund)}
                      />
                      <SellTransactionEstimation
                        deliveryMethod={deliveryMethod}
                      />
                    </div>
                  )}
                </div>
                <div className="col-md-7 col-sm-6 col-xs-12 sell-multiple-address-review-mobile-row">
                  <div className="sell-multiple-address-review-funds-row">
                    <SellFundReviewRow fund={fund} />
                    <div className="sell-multiple-address-review-selected-amount">
                      <SellSelectedFundAmount fund={fund} />
                    </div>
                  </div>

                  <div className="col-md-12 col-sm-12 col-xs-12 sell-multiple-address-review-space">
                    {!isCollegeDistribute() && index === funds.length - 1 && (
                      <SellDeductionsReviewRow
                        selectedFunds={funds}
                        sellTotalAmount={sellTotalAmount}
                        sellTotalDeduction={sellTotalDeduction}
                        address={address}
                      />
                    )}
                  </div>
                </div>
              </div>
            );
          })}

          <SellTradeDateReviewRow
            displayTradeDate={displayTradeDate}
            deliveryMethod={deliveryMethod}
            isTakeHomeEstimated={isTakeHomeEstimated}
            sellTakeHomeAmount={sellTotalTakeHomeAmount}
            sellTotalAmount={sellTotalAmount}
          />
        </div>
      );
    })}
  </div>
);

export default SellMultipleAddressReview;
